module.exports = __webpack_public_path__ + "ecoin-red.png?3cd0aad511ece6f98bcf3959655e47e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ecoin-red.png
// module id = 56
// module chunks = 0